import api from './api';

export default {
    async getUsers(token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/users`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
                throw error;
        }
    },
    async getUsersById(token, id) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/users/${id}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar usuários:', error);
                throw error;
        }
    },
    async inviteUser(token, payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
            const response = await api.post(`/service/users/invite`, payload, {    
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao criar usuário:', error);
            throw error;
        }
    },
    async activateUser(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
            };
            const response = await api.post(`/service/users/activate`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao ativar usuário:', error);
            throw error;
        }
    }   
}
